import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api/v1';

const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  console.debug('[auth-api] request', config.method?.toUpperCase(), config.url, {
    hasToken: Boolean(token),
  });
  return config;
});

api.interceptors.response.use(
  (res) => {
    console.debug('[auth-api] response', res.config.method?.toUpperCase(), res.config.url, {
      status: res.status,
    });
    return res;
  },
  (error) => {
    console.error('[auth-api] response-error', error.config?.method?.toUpperCase(), error.config?.url, {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    if (error.response?.status === 401) {
      localStorage.removeItem('accessToken');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
